import { GraphQLTypes } from 'src/lib/graphqlTypes';

export function isWarningWorkflow(
  workflow: GraphQLTypes.DownstreamTaskCardFragment_downstreamWorkflow | null,
  failsUpstreamWorkflow: boolean | null,
): boolean {
  return (
    failsUpstreamWorkflow === false &&
    workflow?.status === GraphQLTypes.CheckWorkflowStatus.FAILED
  );
}
